import { Button } from "../../../../components/ui/common/button";

interface ProductListPaginationProps {
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

/**
 * Tailwind pagination footer, copied from `IngredientListPagination`
 * (src/screens/lcaIngredients/ingredientList/components/IngredientListPagination.tsx):
 * a count label on the left, Previous/Next `Button`s with a "Page X of Y"
 * label on the right. Replaces the legacy Semantic UI `PaginationView`
 * (src/components/pagination/Pagination.tsx), which also offered a
 * page-size dropdown that this simpler pattern drops.
 */
const ProductListPagination = ({
  totalCount,
  pageNumber,
  totalPages,
  onPageChange
}: ProductListPaginationProps) => (
  <div className="tw-mt-3 tw-flex tw-items-center tw-justify-between">
    <p className="tw-text-xs tw-text-muted-foreground">
      {totalCount} product{totalCount !== 1 ? "s" : ""} found
    </p>
    {totalPages > 1 ? (
      <div className="tw-flex tw-items-center tw-gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber <= 1}
          onClick={() => onPageChange(pageNumber - 1)}
        >
          Previous
        </Button>
        <span className="tw-text-sm tw-text-muted-foreground">
          Page {pageNumber} of {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={pageNumber >= totalPages}
          onClick={() => onPageChange(pageNumber + 1)}
        >
          Next
        </Button>
      </div>
    ) : null}
  </div>
);

export default ProductListPagination;
